import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppWizardModuleState } from '../../models/app-wizard.model';

export const getAppWizardModuleState =
  createFeatureSelector<AppWizardModuleState>('appWizardModule');

export const selectApplicationGroups = createSelector(
  getAppWizardModuleState,
  (state) => state.applicationGroups,
);

export const selectApplications = createSelector(
  getAppWizardModuleState,
  (state) => state.applications,
);

export const selectApplicationRoles = createSelector(
  getAppWizardModuleState,
  (state) => state.roles,
);
